module.exports = __webpack_public_path__ + "img/21_100.18216c78.png";